// extracted by mini-css-extract-plugin
export default {"activeSVG":"exportFileDropdown_activeSVG__IXySo","inactiveSVG":"exportFileDropdown_inactiveSVG__hWRYP"};